import { useEffect, useState } from 'react';
import { useStore } from 'core/store/store.mobx';

export const useScroll = (scrollTo, afterScroll) => {
  const {
    offer: offerStore,
    account: {
      policies: { policy: policyStore }
    }
  } = useStore();
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    if (scrollTo && !scrolled) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setScrolled(true);
        if (afterScroll) {
          afterScroll();
        }
        setTimeout(() => {
          if (offerStore) {
            offerStore.setScrollTo(null);
            setScrolled(false);
          } else if (policyStore) {
            policyStore.setScrollTo(null);
            setScrolled(false);
          }
        }, 1000);
      }
    }
  }, [scrollTo, scrolled, afterScroll, offerStore, policyStore]);
};
